import * as z from 'zod';
export const SHOPIFY_AUDIENCE_MODES = [
    'broad_population',
    'all_customers_overlay',
    'repeat_customers',
    'lapsed_customers',
    'high_value_customers',
    'product_affinity_customers',
    'custom_merchant_segment',
];
export const shopifyAudienceModeSchema = z.enum(SHOPIFY_AUDIENCE_MODES);
/** One pure contract for audience intent across authoring, acceptance and packet compilation. */
export function createShopifyAudienceConflictError() {
    return Object.assign(new Error('Your audience choices do not agree. Reload this setup and choose the customer group again.'), {
        name: 'ShopifyAudienceConflictError',
        code: 'STUDY_BUILDER_AUDIENCE_CONFLICT',
    });
}
export function isShopifyAudienceConflictError(error) {
    return error instanceof Error && 'code' in error && error.code === 'STUDY_BUILDER_AUDIENCE_CONFLICT';
}
/** A missing mode derives from intent; an explicit contradictory assertion is never repaired. */
export function resolveShopifyAudienceMode(mode, hasStoreSelection) {
    if (mode !== undefined && !shopifyAudienceModeSchema.safeParse(mode).success)
        throw createShopifyAudienceConflictError();
    if (hasStoreSelection && mode === 'broad_population')
        throw createShopifyAudienceConflictError();
    return (mode ?? (hasStoreSelection ? 'custom_merchant_segment' : 'broad_population'));
}
/** Editable metadata follows selected intent. Historical persisted input is never changed here. */
export function projectShopifyAudienceMode(mode, hasStoreSelection) {
    return resolveShopifyAudienceMode(hasStoreSelection && mode === 'broad_population' ? undefined : mode, hasStoreSelection);
}
//# sourceMappingURL=shopify-audience-mode.js.map